import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (
  window.location.hostname.includes('test') 
    ? 'https://ope-francis-test.onrender.com' 
    : 'https://ope-francis.onrender.com'
);

const isTestMode = window.location.hostname.includes('test') || window.location.hostname.includes('preview');

const API = `${BACKEND_URL}/api`;

// Configuration axios - retry automatique pour gérer le cold start Render
axios.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config;
    if (!config || config.__retryCount >= 2) {
      return Promise.reject(error);
    }
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || !error.response) {
      config.__retryCount = (config.__retryCount || 0) + 1;
      console.log(`Retry ${config.__retryCount}/2 pour ${config.url}`);
      await new Promise(resolve => setTimeout(resolve, 1500 * config.__retryCount));
      return axios(config);
    }
    return Promise.reject(error);
  }
);

// Jeton « fichiers » court (15 min, usage limité aux routes /content) pour les ressources
// chargées par le navigateur (<img>, <iframe>, <a>, window.open) qui n'envoient pas l'en-tête
// Authorization. Le jeton de session n'est JAMAIS mis dans une URL.
let fileToken = sessionStorage.getItem('file_token') || null;
let fileTokenPromise = null;
const refreshFileToken = () => {
  if (!localStorage.getItem('token')) return Promise.resolve(null);
  if (fileTokenPromise) return fileTokenPromise;
  fileTokenPromise = axios.post(`${API}/auth/jeton-fichiers`, null, { timeout: 20000 })
    .then(r => { fileToken = r.data?.token || null; if (fileToken) sessionStorage.setItem('file_token', fileToken); return fileToken; })
    .catch(() => null)
    .finally(() => { fileTokenPromise = null; });
  return fileTokenPromise;
};
const clearFileToken = () => { fileToken = null; sessionStorage.removeItem('file_token'); };
const withAuthToken = (url) => {
  if (!url) return url;
  if (!fileToken) { refreshFileToken(); return url; }
  return url + (url.includes('?') ? '&' : '?') + 'token=' + encodeURIComponent(fileToken);
};

export { BACKEND_URL, isTestMode, API, withAuthToken, refreshFileToken, clearFileToken };
